import React from 'react';
import logo from '../../images/logo-white.png';
import footerBg from '../../images/footer-bg.png'; // Import your footer background image

const Footer = () => {
    return (
        <>
            <footer
                className="bg-dark text-white py-5"
                style={{
                    backgroundImage: `url(${footerBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                }}
            >
                <div className="container">
                    <div className="row">

                        {/* Box 1: About */}
                        <div className="col-12 col-md-3 mb-4">
                            <img
                                src={logo}
                                alt="Company Logo"
                                className="img-fluid mb-3"
                                style={{ maxWidth: "160px" }}
                            />
                            {/* <h5>About: </h5>
                            <p className="small">
                                OISHI ABASAN, Kshirode Vidyavinode Ave, Baghbazar, Kolkata, West Bengal 700003
                            </p> */}

                            {/* <h5>About:</h5> */}
                            <p className="small">
                                Peregrinee is a new-age IT and digital transformation agency where we specialize in building AI-powered products, scalable software solutions, and transformative digital marketing strategies tailored for global B2B brands.
                            </p>
                            <h5>Phone:</h5>
                            <p className="small">
                                (+91) 98756 45936
                                {/* <br/>
                                (+1) 646-969-3508 */}
                            </p>
                            <h5>Email:</h5>
                            <p className="small">
                                connect@peregrinee.com
                                <br />
                                info@peregrinee.com
                            </p>
                        </div>

                        {/* Box 2: Links */}
                        <div className="col-12 col-md-3 mb-4">
                            <h5>Quick Links</h5>
                            <ul className="list-unstyled small">
                                <li><a href="/" className="text-white text-decoration-none">Home</a></li>
                                <li><a href="/hrias-by-peregrinee" className="text-white text-decoration-none">Hrias</a></li>
                                <li><a href="/services" className="text-white text-decoration-none">Services</a></li>
                                <li><a href="/offshore-development" className="text-white text-decoration-none">Offshore Development</a></li>
                                <li><a href="/case-studies" className="text-white text-decoration-none">Case Studies</a></li>
                                <li><a href="/client-testimonials" className="text-white text-decoration-none">Client Testimonials</a></li>
                                <li><a href="/contact-us" className="text-white text-decoration-none">Contact</a></li>
                            </ul>
                        </div>

                        {/* Box 3: Services */}
                        <div className="col-12 col-md-3 mb-4">
                            <h5>Services</h5>
                            <a href="/custom-software-development" className="text-white text-decoration-none"><p className="small mb-1">Custom Software Development</p></a>
                            <a href="/artificial-intelligence" className="text-white text-decoration-none"><p className="small mb-1">Artificial Intelligence & Data Analytics</p></a>
                            <a href="/ai-agent-development" className="text-white text-decoration-none"><p className="small mb-1">AI Agent Development</p></a>
                            <a href="/minimum-viable-product" className="text-white text-decoration-none"><p className="small mb-1">MVP Development</p></a>
                            <a href="/website-and-app-development" className="text-white text-decoration-none"><p className="small mb-1">Website & Mobile App Development</p></a>
                            <a href="/product-development" className="text-white text-decoration-none"><p className="small mb-1">Product Development</p></a>
                            <a href="/enterprise-web-development" className="text-white text-decoration-none"><p className="small mb-1">Enterprise Web Development</p></a>
                            <a href="/blockchain-development" className="text-white text-decoration-none"><p className="small mb-1">Block Chain</p></a>
                        </div>

                        {/* Box 4: Industries */}
                        <div className="col-12 col-md-3 mb-4">
                            <h5>Industries</h5>
                            <p className="small mb-1"><a href="/healthcare" className="text-white text-decoration-none">Healthcare</a></p>
                            <p className="small mb-1"><a href="/fintech" className="text-white text-decoration-none">Fintech & Insurtech</a></p>
                            <p className="small mb-1"><a href="/retail" className="text-white text-decoration-none">Retail & E-commerce</a></p>
                            <p className="small mb-1"><a href="/entertainment-gaming" className="text-white text-decoration-none">Entertainment & Gaming</a></p>
                            <p className="small mb-1"><a href="/media-communications" className="text-white text-decoration-none">Media & Communications</a></p>
                            {/* <p className="small mb-1"><a href="https://peregrinee.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">Logistics</a></p>
                            <p className="small mb-1"><a href="https://peregrinee.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">Real Estate & Construction</a></p> */}
                        </div>

                    </div>
                </div>
                <p className="text-white mb-0 small text-center">
                    © 2025 - Peregrinee™ - All Rights Reserved
                </p>
            </footer>

            {/* Bottom Footer Text */}

        </>
    );
};

export default Footer;
